import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import NewsModal from './NewsModal';

const News = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPlanToEdit, setSelectedPlanToEdit] = useState(null);
    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [plans, setPlans] = useState([]);
    const [filteredPlans, setFilteredPlans] = useState(plans);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;


    const fetchDataPlan = async () => {
        try {
            const response = await fetch(`https://backend.impactjournal.co.in/news`)
            const res = await response.json();
            console.log(res);
            setPlans(res);
        } catch (error) {
            console.log(error)
        }
    }
    // Effect to handle filtering
    useEffect(() => {
        const filtered = plans.filter((plan) =>
            Object.values(plan).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredPlans(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, plans]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredPlans.length / itemsPerPage);
    const currentData = filteredPlans.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);


  

    const handleDelete = (id, index) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to delete this plan?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`https://backend.impactjournal.co.in/news/${id}`, {
                        method: "DELETE"
                    });
                    if (res.ok) {
                        // Remove the item from local state
                        const updatedPlans = [...plans];
                        updatedPlans.splice(index, 1);
                        setPlans(updatedPlans);

                        Swal.fire('Deleted!', 'Plan has been deleted.', 'success');
                    } else {
                        Swal.fire('Error!', 'Failed to delete plan.', 'error');
                    }
                } catch (error) {
                    console.error("Delete error:", error);
                    Swal.fire('Error!', 'Something went wrong.', 'error');
                }
            }
        });
    };


    useEffect(() => {
        fetchDataPlan();
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">News</h1>

                    {/* Add Fees Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add News
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Plan Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Heading</th>
                                <th>Description</th>
                            
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((plan, index) => (
                                    <tr key={index}>
                                        <td>{new Date(plan.date).toLocaleDateString('en-GB')}</td>
                                        <td>{plan.heading}</td>
                                      
                                        <td>{plan.description}</td>
                                        <td>
                                            
                                            <button onClick={() => {
                                                setSelectedPlanToEdit(plan);
                                                setIsModalOpen(true);
                                            }}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>


                                            <button onClick={() => handleDelete(plan.id, index)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>
                                        No plans found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>


            <NewsModal
                isOpen={isModalOpen}
                setIsOpen={(val) => {
                    setIsModalOpen(val);
                    if (!val) setSelectedPlanToEdit(null);
                }}
                editData={selectedPlanToEdit} // pass null for create
                fetchPlans={fetchDataPlan}
            />

        </>
    );
};

export default News;
